import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, LogOut, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function RoomShell({ title, kicker, children, testid }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen lamp-glow" data-testid={testid} style={{ background: "var(--deep-shadow)" }}>
      <header className="sticky top-0 z-40 backdrop-blur-md" style={{ background: "rgba(10,7,5,0.82)", borderBottom: "1px solid rgba(245,158,11,0.15)" }}>
        <div className="mx-auto max-w-6xl px-5 py-4 flex items-center justify-between gap-4">
          <button
            data-testid="back-to-hq-btn"
            onClick={() => navigate("/")}
            className="flex items-center gap-2 font-typewriter text-xs uppercase tracking-[0.2em] text-[#F59E0B] hover:text-[#FDF6E3] transition-colors"
          >
            <ArrowLeft size={16} /> Headquarters
          </button>
          <div className="flex items-center gap-3">
            {user ? (
              <>
                <button
                  data-testid="profile-link-btn"
                  onClick={() => navigate("/profile")}
                  className="flex items-center gap-2 font-typewriter text-xs uppercase tracking-widest text-[#A89A80] hover:text-[#F59E0B] transition-colors"
                >
                  <User size={15} /> {user.investigator_number}
                </button>
                <button
                  data-testid="logout-btn"
                  onClick={logout}
                  className="text-[#A89A80] hover:text-[#991B1B] transition-colors"
                  title="Log out"
                >
                  <LogOut size={16} />
                </button>
              </>
            ) : (
              <button
                data-testid="enter-hq-btn"
                onClick={() => navigate("/enter")}
                className="font-typewriter text-xs uppercase tracking-widest text-[#F59E0B] hover:text-[#FDF6E3] transition-colors"
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </header>

      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-6xl px-5 py-12"
      >
        {kicker && (
          <p className="font-typewriter text-xs uppercase tracking-[0.35em] text-[#D97706] mb-3">{kicker}</p>
        )}
        <h1 className="font-serif-hq text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#FDF6E3] mb-10">
          {title}
        </h1>
        {children}
      </motion.main>
    </div>
  );
}
